import { baseTheme } from '@src/theme';
import styled from 'styled-components';
import { Typography } from '../Typography';

// Create a styled wrapper for the Input component to apply theme-based styling
export const StyledInputWrapper = styled.div`
    .ant-input,
    .ant-input-affix-wrapper {
        &:focus,
        &.ant-input-focused,
        &:focus-within {
            border-color: ${(props) =>
                props.theme?.colors?.primary?.main?.border ||
                baseTheme.colors.primary.main.border} !important;
            border-width: 1px !important;
        }

        &.ant-input-status-error {
            border-color: ${(props) =>
                props.theme?.colors?.error?.main?.border ||
                baseTheme.colors.error.main.border} !important;
        }

        &:disabled {
            border-color: ${(props) =>
                props.theme?.colors?.secondary?.light?.border ||
                baseTheme.colors.secondary.light.border} !important;
            background-color: ${(props) =>
                props.theme?.colors?.secondary?.light?.surfaceBg ||
                baseTheme.colors.secondary.light.surfaceBg} !important;
        }

        &:not(.ant-input-status-error):not(:disabled):not(:focus):not(
                .ant-input-focused
            ) {
            border-color: ${(props) =>
                props.theme?.colors?.secondary?.main?.divider ||
                baseTheme.colors.secondary.main.divider} !important;
        }

        // Add hover state border color
        &:hover:not(:disabled):not(.ant-input-status-error) {
            border-color: ${(props) =>
                props.theme?.colors?.primary?.light?.border ||
                baseTheme.colors.primary.light.border} !important;
        }
    }
`;

export const StyledLabel = styled(Typography)`
    color: ${(props) =>
        props.theme?.colors?.secondary?.main?.text ||
        baseTheme.colors.secondary.main.text};
`;

export const StyledRequiredMark = styled.span`
    font-size: 1.125rem;
    color: ${(props) =>
        props.theme?.colors?.error?.main?.text ||
        baseTheme.colors.error.main.text};
`;

export const StyledError = styled(Typography)`
    color: ${(props) =>
        props.theme?.colors?.error?.main?.text ||
        baseTheme.colors.error.main.text};
`;
